import { Controller } from "@hotwired/stimulus"

// Keeps the Better/Best column headers' selection counts and the per-category
// select-all checkboxes in sync with the premium amenity checkboxes.
export default class extends Controller {
  static targets = ["bestCount", "bestInput", "betterCount", "betterInput", "categoryToggle"]

  connect() {
    this.recount()
  }

  recount() {
    this.bestCountTarget.textContent = this.bestInputTargets.filter((input) => input.checked).length
    this.betterCountTarget.textContent = this.betterInputTargets.filter((input) => input.checked).length

    this.categoryToggleTargets.forEach((toggle) => {
      const inputs = this.tierInputs(toggle.dataset.tier).filter(
        (input) => input.dataset.category === toggle.dataset.category
      )
      const checked = inputs.filter((input) => input.checked).length

      toggle.checked = inputs.length > 0 && checked === inputs.length
      toggle.indeterminate = checked > 0 && checked < inputs.length
    })
  }

  tierInputs(tier) {
    return tier === "best" ? this.bestInputTargets : this.betterInputTargets
  }

  toggleCategory(event) {
    const { category, tier } = event.target.dataset

    this.tierInputs(tier)
      .filter((input) => input.dataset.category === category)
      .forEach((input) => {
        input.checked = event.target.checked
      })

    this.recount()
  }
}
